
import React from 'react';
import Input from '../../../../components/ui/Input';
import { ClientProfile } from '../../../../types';

interface AddressCardProps {
    formData: ClientProfile;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AddressCard: React.FC<AddressCardProps> = ({ formData, onChange }) => {
    return (
        <div className="card-premium p-4">
            <h3 className="text-sm font-bold text-secondary mb-4">Endereço</h3>
            <div className="space-y-4">
                <Input
                    name="address.line1"
                    autoComplete="street-address"
                    value={formData.address?.line1 || ''}
                    onChange={onChange}
                    placeholder="Endereço (Rua, número, complemento)"
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Input
                        name="address.city"
                        autoComplete="address-level2"
                        value={formData.address?.city || ''}
                        onChange={onChange}
                        placeholder="Cidade"
                    />
                    <div className="grid grid-cols-3 gap-4">
                        <Input
                            containerClassName="col-span-1"
                            name="address.state"
                            autoComplete="address-level1"
                            value={formData.address?.state || ''}
                            onChange={onChange}
                            placeholder="UF"
                            maxLength={2}
                        />
                        <Input
                            containerClassName="col-span-2"
                            name="address.zip"
                            autoComplete="postal-code"
                            value={formData.address?.zip || ''}
                            onChange={onChange}
                            placeholder="CEP"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
